import { cookieManager, getExpBucket } from "utils";

export type WindowWithFandomContext = Window & {
  fandomContext: {
    experimentBucket?: number;
  };
};
export type BucketingProvider = () => number;

/*
 * Reads and stores sampling from cookie and/or window variable 'fandomContext.experimentBucket' set by AE Loader
 */
export const labradorBucketProvider = (
  container: WindowWithFandomContext,
): BucketingProvider => {
  const experimentBucket = Number(
    container.fandomContext?.experimentBucket ??
      cookieManager.get("eb") ??
      Math.floor(Math.random() * 100),
  );

  container.fandomContext = container.fandomContext || {};
  container.fandomContext.experimentBucket = experimentBucket;

  return () => experimentBucket;
};

/**
 * Returns the current experiment bucket value from the utils package.
 */
export const experimentBucketProvider: BucketingProvider = () =>
  Number(getExpBucket());
